const uri = '/webapi/xm/1/people';

export const USERS_PROFILE_PAGE_POST_USER = 'USERS_PROFILE_PAGE_POST_USER';
export const EDIT_PROFILE_OPEN_DIALOG = 'EDIT_PROFILE_OPEN_DIALOG';
export const EDIT_PROFILE_CLOSE_DIALOG = 'EDIT_PROFILE_CLOSE_DIALOG';

export const editProfile = person => ({
  type: USERS_PROFILE_PAGE_POST_USER,
  meta: {
    xmApi: true,
    method: 'post',
    uri: `${uri}`,
    params: person,
  },
});

export const openDialog = () => ({
  type: EDIT_PROFILE_OPEN_DIALOG,
});

export const closeDialog = () => ({
  type: EDIT_PROFILE_CLOSE_DIALOG,
});
